import { Box } from "@mui/material";
import { StyledCardMedia, StyledCardMediaMyTrack } from "../styles";
import { ArtWorkProps } from "../types";

export const ArtWork: React.FC<ArtWorkProps> = ({ expand, image }) => {
  return (
    <Box>
      {expand ? (
        <StyledCardMedia
          image={image?.includes("http") ? image : `/assets/images/logo512.png`}
        />
      ) : (
        <StyledCardMediaMyTrack
          image={image?.includes("http") ? image : `/assets/images/logo512.png`}
        />
      )}
    </Box>
  );
};
